import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface BulkPrescreenCandidateJobParams {
  jobId: string;
  candidateIds: string[];
}

export const useBulkPrescreenCandidateJobMutation = () => {
  return useMutation({
    mutationFn: async ({
      jobId,
      candidateIds,
    }: BulkPrescreenCandidateJobParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.prescreenCandidates,
        {
          params: {
            path: { jobId },
          },
          body: { candidateIds },
        },
      );

      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { jobId } = variables;
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
    },
  });
};
